module.exports = __webpack_public_path__ + "static/img/btc.c65c97c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/btc.jpg
// module id = vQCk
// module chunks = 1